<template lang="pug">
modal#new-developer-client-modal(
  :close='onCloseModal'
  :close-button-label='$t("modal.newDeveloperClient.closeButtonLabel")'
  :process-button-label='$t("modal.newDeveloperClient.processButtonLabel")'
  :title='$t("modal.newDeveloperClient.title")'
  @closed='onCloseModal'
  @process='submit'
  ref='modal'
)
  ValidationObserver(ref='form')
    form.form(@submit.prevent='submit')
      .row
        .col-12
          ValidationProvider(
            :name='$t("modal.newDeveloperClient.nameLabel").toLowerCase()'
            rules='required'
            v-slot='{ errors }'
          )
            .form-group
              label(for='name') {{ $t('modal.newDeveloperClient.nameLabel') }}*
              .form-control-icon
                icon(name='building')
                input#name.form-control(
                  :class='{ "is-invalid": errors.length }'
                  :placeholder='$t("modal.newDeveloperClient.namePlaceholder")'
                  autocomplete='off'
                  type='name'
                  v-model='name'
                )
              small.text.text-danger {{ errors[0] }}
        .col-12
          ValidationProvider(
            :name='$t("modal.newDeveloperClient.urlLabel")'
            rules='required|url'
            v-slot='{ errors }'
          )
            .form-group
              label(for='email') {{ $t('modal.newDeveloperClient.urlLabel') }}*
              .form-control-icon
                icon(name='globe')
                input#email.form-control(
                  :class='{ "is-invalid": errors.length }'
                  :placeholder='$t("modal.newDeveloperClient.urlPlaceholder")'
                  type='text'
                  v-model='url'
                )
              small.text.text-danger {{ errors[0] }}
        .col-12
          .form-switch.d-flex.align-items-center
            input#checked-public.form-check-input(
              type='checkbox'
              v-model='public'
            )
            span(style='margin-left: 0.5rem; vertical-align: bottom') {{ $t('modal.newDeveloperClient.publicLabel') }}
            icon(
              data-placement='top'
              data-toggle='tooltip'
              name='circle-question'
              style='cursor: pointer; margin-left: 0.5rem'
              v-tooltip:top='tooltipText'
            )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import OauthService from '@/services/Oauth';
import alert from '@/modules/account/common/alert';

export default {
  name: 'NewDeveloperClientModal',
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      name: '',
      url: '',
      public: false,
    };
  },
  methods: {
    onCloseModal() {
      this.name = '';
      this.url = '';
      this.public = false;
      this.$refs.form.reset();
    },
    submit() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.$loading(true);
        const pattern = /^((http|https|ftp):\/\/)/;
        if (!pattern.test(this.url)) {
          this.url = `http://${this.url}`;
        }
        OauthService.createClient({
          name: this.name,
          redirect: this.url,
          confidential: !this.public,
        })
          .then((result) => {
            this.$refs.modal.close();
            alert.fireAlert(
              this.$t('modal.newDeveloperClient.successMessage'),
              {
                classes: 'alert-success',
                styles:
                  'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
                icon: 'circle-check',
              }
            );
            this.$emit('refresh');
            if (result.data.plain_secret) {
              this.$emit('showClientSecret', result.data.plain_secret);
              return;
            }
            this.$emit('showInfoModal');
          })
          .finally(() => {
            this.$loading(false);
          });
      });
    },
  },
  computed: {
    tooltipText() {
      // eslint-disable-next-line max-len
      return this.$t('modal.newDeveloperClient.tooltipText');
    },
  },
};
</script>

<style scoped lang="stylus">
#new-developer-client-modal
  z-index: 1060;
</style>
